import { putActivateOrDeactivateSmsCampaign } from '../services';
export const activateOrDeactivateSmsCampaign = (campaignId, status) => putActivateOrDeactivateSmsCampaign(campaignId, status)
    .then(response => formatResponse(response?.data))
    .catch(() => false);
const formatResponse = (response) => {
    return response.success;
};
